// extracted by mini-css-extract-plugin
export default {"container":"Card_container__Eu9CF","container--border":"Card_container--border__EW+wv","container--padding":"Card_container--padding__DxoJ9"};